import { ChevronDown, Loader2, MonitorPlay } from 'lucide-react';

export function Loading() {
  return (
    <div className="flex items-center justify-center py-20">
      <Loader2 className="h-6 w-6 animate-spin text-[var(--dash-brand)]" />
    </div>
  );
}

export function Empty({ text }: { text: string }) {
  return (
    <div className="rounded-2xl border border-dashed border-[var(--dash-line)] bg-white px-4 py-16 text-center">
      <MonitorPlay className="mx-auto h-8 w-8 text-[var(--dash-muted)] opacity-30" />
      <p className="mt-3 mb-0 text-sm font-semibold text-[var(--dash-ink)]">{text}</p>
    </div>
  );
}

export function KpiCard({
  label,
  value,
  color,
  bg,
}: {
  label: string;
  value: string | number;
  color: string;
  bg: string;
}) {
  return (
    <div className={`rounded-2xl border border-[var(--dash-line)] p-4 text-center shadow-sm ${bg}`}>
      <p className={`m-0 text-2xl font-bold ${color}`}>{value}</p>
      <p className="m-0 mt-1 text-[10px] font-semibold tracking-wider text-[var(--dash-muted)] uppercase">
        {label}
      </p>
    </div>
  );
}

export function FilterDropdown({
  label,
  value,
  onChange,
  options,
  allLabel = 'All',
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: Array<{ value: string; label: string }>;
  allLabel?: string;
}) {
  return (
    <div>
      <label className="mb-1 block text-[10px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase">
        {label}
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="cursor-pointer appearance-none rounded-xl border border-[var(--dash-line)] bg-[var(--dash-soft)] py-2 pr-9 pl-3.5 text-sm font-semibold text-[var(--dash-ink)] outline-none focus:border-[var(--dash-brand)]"
        >
          <option value="">{allLabel}</option>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDown
          className="pointer-events-none absolute top-1/2 right-2.5 h-4 w-4 -translate-y-1/2 text-[var(--dash-muted)]"
          aria-hidden
        />
      </div>
    </div>
  );
}

